export default __webpack_public_path__ + "static/media/husband-holding-wife.3496dd6f.svg";